//审核数量
import {contractApi} from "@/axios";
//审核数量
export function getAuditCount(type,data){
    return contractApi({
        url:'/approval/pending/'+type,
        method:'post',
        data:data
    })
}